module.exports = __webpack_public_path__ + "img/Mist.82765100.png";